export var PROPERTY_CARD_APPEARANCES = Object.freeze({
  LARGE: 'large',
  SMALL: 'small',
  HORIZONTAL: 'horizontal',
  FLAG: 'flag'
});